export default __webpack_public_path__ + "static/media/supply-demand-money.1fd9e882.png";